export default [
    {
        path: '/faq-questions',
        name: 'faq-questions',
        component: () => import ('./pages/Index')
    },
]